import React from 'react';
import type { QuestionOption } from '../types';

interface ChooseMultipleProps {
  options: QuestionOption[];
  selectedIds: number[];
  onChange: (optionIds: number[]) => void;
  disabled?: boolean;
}

export default function ChooseMultiple({
  options,
  selectedIds,
  onChange,
  disabled = false,
}: ChooseMultipleProps) {
  const toggle = (id: number) => {
    if (disabled) return;
    const set = new Set(selectedIds);
    if (set.has(id)) set.delete(id);
    else set.add(id);
    onChange(Array.from(set));
  };

  const optionsWithId = options.filter((opt): opt is QuestionOption & { id: number } => opt.id != null);

  return (
    <div className="choose-multiple" role="group">
      {optionsWithId.map((opt) => (
        <label key={opt.id} className="choose-multiple__option">
          <input
            type="checkbox"
            checked={selectedIds.includes(opt.id)}
            onChange={() => toggle(opt.id)}
            disabled={disabled}
            className="choose-multiple__input"
          />
          <span className="choose-multiple__label">{opt.option_label}</span>
        </label>
      ))}
    </div>
  );
}
